


export enum EditorState{
    Normal,//free for user to interact 
    Dragging,//dragging
    EditingContent,//editor is focused on a single element for text editing
    Resizing,//resizing an element
    MovingAbsolute,//moving an absolute element
    TemplateMenu, // template or context menus, easy way to take away control from the designer
    Preview, //previewing the page
    InPannelMenu,// when in general settings or other menus (could probably  just use a canvas sized dom to block pointer events buuuuut)
    Locked,//locked, no interaction
}

export enum PannelMenuType{
    None,
    GeneralSettings,
    Domains,
    ChangeStyle,
    EditorSettings,
    AnnouncementBar,
    CookieBanner,
    Multilocation,



}

export enum ResizeType {
    None,
    Left,
    Right,
    Top,
    Bottom,
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight
  }
